import Cookies from 'js-cookie';
import MoneyTool from '@utils/MoneyTool';
import moment from 'moment';

class InstalmentCalculator
{
    defineInstCalcSliderAnimationJqueryPlugin() {

        //INST calc animation
        $.fn.animateInstCalcSlider = function(opts) {

            $.extend({
                dataSelector: 'plugin_instLoanCalc'
            }, opts);

            var calc = $(this).data(opts.dataSelector);

            var min = calc.getMinLoanAmount();
            var max = calc.getMaxLoanAmount();
            // var minMonth = calc.getMinInstallmentCount();
            var minMonth = calc.getStartingInstallmentCount() - 1;
            // var maxMonth = calc.getMaxInstallmentCount();
            var maxMonth = calc.getStartingInstallmentCount();
            var starting = calc.getStartingLoanAmount();
            var step = calc.settings.sliderStep;
            var queue = [];
            var monthQueue = [];

            if(step == 100 || step ==200) {
                step = step * 5;
            } else if(step == 500 || step == 1000) {
                step = step * 2;
            }

            var num = min;
            while (num <= max) {
                queue.push(num);
                num = num + step;
            }

            var mNum = minMonth;
            while (mNum <= maxMonth) {
                monthQueue.push(mNum);
                mNum++;
            }

            if (num != max) {
                queue.push(max);
            }

            if (mNum != maxMonth) {
                monthQueue.push(maxMonth);
            }

            num = max;
            num = max - step;
            while (num >= starting) {
                queue.push(num);
                num = num - step;
            }

            if (num != starting) {
                queue.push(starting);
            }

            queue.reverse();
            monthQueue.reverse();

            var executeNext = function (num)  {
                var delay = 10;
                // console.log(num);
                calc.$loanAmount.val(num).trigger('change');
                if(num == max) {
                    // console.log('set delay');
                    delay = 1000;
                }
                setTimeout(function () {
                    if (queue.length > 0) {
                        executeNext(queue.pop());
                    }

                }, delay);
            };

            var executeNextMonth = function (monthNum)  {
                var delay = 100;
                // console.log(monthNum);
                calc.$installmentCount.val(monthNum).trigger('change');

                setTimeout(function () {
                    if (monthQueue.length > 0) {
                        executeNextMonth(monthQueue.pop());
                    }

                }, delay);
            };

            if (queue.length > 0) {
                executeNext(queue.pop());
            }

            if (monthQueue.length > 0) {
                executeNextMonth(monthQueue.pop());
            }

            return $(this);
        };
    }

    defineInstCalcJqueryPlugin()
    {
        (function($, window, document, undefined) {
            "use strict";

            var pluginName = "instLoanCalc",
                defaults = {
                    currentDate: null,
                    loanAmount: 0.00,
                    installmentCount: 0,
                    loanAmountLimits: [],
                    minAmount: 0.00,
                    maxAmount: 0.00,
                    minLoanIncreaseAmount: 0.00,
                    minInstallmentCount: 0,
                    maxInstallmentCount: 0,
                    rolloverRates: {},
                    vatRate: 0.00,
                    messages: {
                        minLoanNumberRequirementGeneral: 'Amount available at {number}. loan',
                        minLoanNumberRequirementLast: 'Amount available at {number}+. loan',
                        minLoanNumberRequirement2nd: 'Amount available at 2nd loan',
                        minLoanNumberRequirement3rd: 'Amount available at 3rd loan',
                        minLoanNumberRequirement4th: 'Amount available at 4th loan or more',
                        loanNotAvailable: 'Your maximum loan amount is exceeded',
                        currentLoanOverdue: 'Your active loan is overdue. Please extend the term or repay it.',
                        insufficientIncreaseTerm: 'Insufficient loan increase term',
                        insufficientLoanLimit: 'Your loan limit is exceeded',
                        cyclePayment: {}
                    },
                    appUrls: {
                        firstTime: '',
                        repeated: '',
                        authorized: ''
                    },
                    calcApiUrl: '',
                    minLoanTerm: 2,
                    dateFormat: 'DD/MM/YYYY',
                    shortDateFormat: 'DD/MM',
                    payCycle: 'weekly',
                    payCycles: {},
                    nextPayDate: null,
                    payDateOfMonth: null,
                    semiMonthlyPayDates: null,
                    isLoanAvailable: true,
                    isLoanIncrease: false,
                    authorized: false,
                    onUpdate: null,
                    currentLoanOverdue: false,
                    insufficientIncreaseTerm: false,
                    insufficientLoanLimit: false,
                    firstLoanZeroInterestEnabled: false,
                    isFirstLoan: false,
                    customEndDate: null,
                    debug: false,
                    agTermEndDate: null,
                    persistValues: true,
                    semiMonthlyPayDateChoices: {},
                    forceRepeatedLoan: true,
                    sliderStep: null,
                    sliderTimeout: 0
                };

            function InstLoanCalc(element, options) {

                this.element = element;
                this.settings = $.extend({}, defaults, options);

                if (this.settings.debug) {
                    console.log(this.settings);
                }

                this._defaults = defaults;
                this._name = pluginName;

                this.currentDate = this.toDate(this.settings.currentDate);
                this.agTermEndDate = this.toDate(this.settings.agTermEndDate);

                this.$calc = $(this.element);
                this.$payCycle = this.$calc.find('.pay_cycle');
                this.$principalAmount = this.$calc.find('.principal_amount');
                this.$commAmount = this.$calc.find('.comm_amount');
                this.$totalAmount = this.$calc.find('.total_amount');
                this.$commVatAmount = this.$calc.find('.comm_vat_amount');
                this.$totalVatAmount = this.$calc.find('.total_vat_amount');

                this.$loanAmount = this.$calc.find('input[name="calc_newuser_amount"]');
                this.$installmentCount = this.$calc.find('input[name="calc_duration"]');

                this.$nextPayDate = this.$calc.find('.next_pay_date');
                this.$payDateOfMonth = this.$calc.find('.pay_date_of_month');
                this.$semiMonthlyPayDates = this.$calc.find('.semi_monthly_pay_dates');
                this.$endDateLabel = this.$calc.find('.end_date_label');
                this.$fullEndDateLabel = this.$calc.find('.full_end_date_label');
                this.$fullAgTermEndDateLabel = this.$calc.find('.full_ag_term_end_date_label');
                this.$installmentCountLabel = this.$calc.find('.installment_count_label');

                this.$cyclePaymentLabel = this.$calc.find('.cycle_payment_label');

                this.$nextRolloverDays = this.$calc.find('.next_rollover_days');
                this.$nextRolloverFee = this.$calc.find('.next_rollover_fee');
                this.$nextRolloverFeeExclVat = this.$calc.find('.next_rollover_fee_excl_vat');
                this.$nextRolloverDate = this.$calc.find('.next_rollover_date');

                this.$firstTimeLoanBtn = this.$calc.find('.first_time_loan_btn');
                this.$repeatedLoanBtn = this.$calc.find('.repeated_loan_btn');

                this.$loanAmountSlider = this.$calc.find('.jqueryui_slider.loan_amount_slider');
                this.$inpHint = this.$calc.find('.inp_hint_msg');

                this.$scheduleBtn = this.$calc.find('.schedule_btn');

                this.$installmentCountSlider = this.$calc.find('.jqueryui_slider.installment_count_slider');

                this.$appBtn = this.$calc.find('.app_btn');
                this.$repaymentTooltip = this.$calc.find('.repayment_tooltip');

                this.$regularApplyBtnHolder = this.$calc.find('.regular_apply_btn_holder');
                this.$specialApplyBtnHolder = this.$calc.find('.special_apply_btn_holder');

                this.nextPayDate = null;
                this.payDateOfMonth = null;
                this.semiMonthlyPayDates = null;

                this.endDate = null;
                this.adjustedEndDate = null;
                this.rolloverDate = null;
                this.adjustedRolloverDate = null;

                this.loanTerm = null;
                this.payCycle = null;

                this.$nextPayDateSelector = this.$calc.find('.next_pay_date_selector');
                this.$payDateOfMonthSelector = this.$calc.find('.pay_date_of_month_selector');
                this.$semiMonthlyPayDatesSelector = this.$calc.find('.semi_monthly_pay_dates_selector');

                this.nextPayDateInitialized = false;
                this.payDateOfMonthInitialized = false;
                this.semiMonthlyPayDatesInitialized = false;

                this.rqInProgress = null;
                this.updateInProgress = null;

                this.init();
            }

            InstLoanCalc.ISO_DATE_FORMAT = 'YYYY-MM-DD';

            $.extend(InstLoanCalc.prototype, {
                init: function() {
                    var that = this;

                    //prevent enter
                    this.$loanAmount.on('keypress', function(e) {
                        if (e.keyCode === 10 || e.keyCode === 13) {
                            e.preventDefault();
                            $(this).trigger('change');
                        }
                    });

                    this.$installmentCount.on('keypress', function(e) {
                        if (e.keyCode === 10 || e.keyCode === 13) {
                            e.preventDefault();
                            $(this).trigger('change');
                        }
                    });

                    this.$repaymentTooltip.on('click', function(e) {
                        e.preventDefault();
                    });

                    this.$appBtn.on('click', function(e) {
                        if ($(this).hasClass('disabled')) {
                            e.preventDefault();
                        }
                    });

                    this.$loanAmount.on('change', function (event, context) {
                        var isSlider = "undefined" !== typeof context &&
                            "undefined" !== typeof context.source && context.source === 'slider';

                        var isMinusBtn = "undefined" !== typeof context &&
                            "undefined" !== typeof context.source && context.source === 'minus_button';

                        var loanAmount = that.toInt(that.$loanAmount.val());
                        var step = that.settings.sliderStep;
                        var isLoanIncrease = that.settings.isLoanIncrease;
                        var minLoanIncreaseAmount = that.toInt(that.settings.minLoanIncreaseAmount);

                        var minAmount = that.getMinLoanAmount();
                        var maxAmount = that.getMaxLoanAmount();

                        if (loanAmount > maxAmount) {
                            that.$loanAmount.val(maxAmount).trigger('change');
                        } else if (loanAmount < minAmount) {
                            that.$loanAmount.val(minAmount).trigger('change');
                        } else if (step > 0 && loanAmount % step !== 0
                            && loanAmount !== minAmount && loanAmount !== maxAmount) {
                            loanAmount = Math.round(loanAmount / step) * step;
                            that.$loanAmount.val(loanAmount).trigger('change');
                        } else if (isLoanIncrease && (loanAmount > 0 && loanAmount < minLoanIncreaseAmount)
                            && maxAmount >= minLoanIncreaseAmount)
                            that.$loanAmount.val(isMinusBtn ? 0 : minLoanIncreaseAmount).trigger('change');
                        else {
                            that.update(isSlider);
                        }
                    });

                    this.$installmentCount.on('change', function(event, context) {
                        var isSlider = "undefined" !== typeof context &&
                            "undefined" !== typeof context.source && context.source === 'slider';
                        var insCnt = that.toInt(that.$installmentCount.val());
                        if (insCnt > that.getMaxInstallmentCount()) {
                            that.$installmentCount.val(that.getMaxInstallmentCount()).trigger('change');
                        } else if (insCnt < that.getMinInstallmentCount()) {
                            that.$installmentCount.val(that.getMinInstallmentCount()).trigger('change');
                        } else {
                            that.update(isSlider);
                        }
                    });

                    var onPayDateChanged = function(payDate) {
                        that.update(false);
                    };

                    that.$nextPayDate.on('change', function () {
                        var payDate = that.toDate($(this).val());
                        that.nextPayDate = payDate;
                        onPayDateChanged(payDate);
                    });

                    that.$payDateOfMonth.on('change', function () {
                        var payDay = that.toInt($(this).val());
                        that.payDateOfMonth = payDay;
                        var currentDay = that.currentDate.date();
                        var payDate = moment(that.currentDate);
                        if (payDay <= currentDay) {
                            payDate.add(1, 'M');
                        }
                        var daysInMonth = payDate.daysInMonth();
                        payDate.date(payDay > daysInMonth ? daysInMonth : payDay)
                        onPayDateChanged(payDate);
                    });

                    that.$semiMonthlyPayDates.on('change', function () {
                        that.semiMonthlyPayDates = $(this).val();
                        var nextPayDates = getPossibleNextPayDateValues(that.currentDate, that.payCycle, 0, that.semiMonthlyPayDates);
                        var payDate = nextPayDates[nextPayDates.length - 1];
                        onPayDateChanged(payDate);
                    });

                    this.$firstTimeLoanBtn.on('change', function() {
                        that.update(false);
                    });

                    this.$repeatedLoanBtn.on('change', function() {
                        that.update(false);
                    });

                    var startingLoanAmount = this.getStartingLoanAmount();
                    this.$loanAmountSlider.data('min', this.getMinLoanAmount());
                    this.$loanAmountSlider.data('max', this.getMaxLoanAmount());
                    this.$loanAmountSlider.data('val', startingLoanAmount);
                    this.$loanAmountSlider.data('step', this.settings.sliderStep);
                    this.$loanAmount.val(startingLoanAmount);

                    var startingInstCount = this.getStartingInstallmentCount();
                    this.$installmentCountSlider.data('min', this.getMinInstallmentCount());
                    this.$installmentCountSlider.data('max', this.getMaxInstallmentCount());
                    this.$installmentCountSlider.data('val', startingInstCount);
                    this.$installmentCountSlider.data('step', 1);
                    this.$installmentCount.val(startingInstCount);

                    this.$firstTimeLoanBtn.data('oncheck-limitsliderval', this.getFirstLoanMaxAmount());
                    this.$loanAmount.data('newusermaxval', this.getFirstLoanMaxAmount());

                    this.$payCycle.on('change', function() {
                        that.payCycle = $(this).val();
                        that.$nextPayDateSelector.addClass('hidden');
                        that.$payDateOfMonthSelector.addClass('hidden');
                        that.$semiMonthlyPayDatesSelector.addClass('hidden');
                        if (that.payCycle == 'monthly') {
                            that.$payDateOfMonthSelector.removeClass('hidden');
                            var defVal = 15;
                            if (! that.payDateOfMonthInitialized && that.settings.payDateOfMonth !== null) {
                                defVal = that.settings.payDateOfMonth;
                            }
                            that.payDateOfMonthInitialized = true;
                            that.$payDateOfMonth.val(defVal).trigger('change');
                        } else if (that.payCycle == 'semi_monthly') {
                            that.$semiMonthlyPayDatesSelector.removeClass('hidden');
                            var defVal = '15_30';
                            if (! that.semiMonthlyPayDatesInitialized && that.settings.semiMonthlyPayDates !== null) {
                                defVal = that.settings.semiMonthlyPayDates;
                            }
                            that.semiMonthlyPayDatesInitialized = true;
                            that.$semiMonthlyPayDates.val(defVal).trigger('change');
                        } else {
                            that.$nextPayDateSelector.removeClass('hidden');
                            that.$nextPayDate.empty();
                            var lastVal = '';
                            var dateValues = getPossibleNextPayDateValues(that.currentDate, that.payCycle, 0, null);
                            for (var i = 0; i < dateValues.length; i++) {
                                var date = dateValues[i];
                                var val = date.format(InstLoanCalc.ISO_DATE_FORMAT);
                                that.$nextPayDate.append('<option value="' + val + '">' + date.format(that.settings.dateFormat)  + '</option>');
                                lastVal = val;
                            }
                            if (! that.nextPayDateInitialized && that.settings.nextPayDate !== null
                                && that.$nextPayDate.find('option[value="' + that.settings.nextPayDate + '"]').length > 0
                            ) {
                                lastVal = that.settings.nextPayDate;
                            }
                            that.nextPayDateInitialized = true;
                            that.$nextPayDate.val(lastVal).trigger('change');
                        }
                    }).val(this.settings.payCycle).trigger('change');
                },

                update: function (isSlider) {

                    this.$cyclePaymentLabel.html(this.settings.messages.cyclePayment[this.payCycle]);

                    this.$appBtn.attr('href',
                        this.settings.authorized ? this.settings.appUrls.authorized :
                            ((this.$firstTimeLoanBtn.is(':checked') ? this.settings.appUrls.firstTime : this.settings.appUrls.repeated))
                    );


                    var that = this;
                    var loanAmount = this.toInt(this.$loanAmount.val());
                    var installmentCount = this.toInt(this.$installmentCount.val());
                    var payCycle = this.$payCycle.val();
                    var payDateOfMonth = this.$payDateOfMonth.val();
                    var semiMonthlyPayDates = this.$semiMonthlyPayDates.val();
                    var referenceDate = this.nextPayDate === null ? '' : this.nextPayDate.format(InstLoanCalc.ISO_DATE_FORMAT);

                    var minLoanNumber = this.getRequiredLoanNumber(loanAmount);
                    this.$inpHint.html(this.getMinLoanNumberMessage(minLoanNumber));


                    if (this.settings.isLoanAvailable) {
                        if (loanAmount > 0 || installmentCount > 0) {
                            this.$regularApplyBtnHolder.show();
                            this.$specialApplyBtnHolder.hide();
                        } else {
                            this.$regularApplyBtnHolder.hide();
                            this.$specialApplyBtnHolder.show();
                        }
                    }

                    if (this.settings.debug) {
                        console.log('Upd');
                        console.log('Loan amount: ', loanAmount);
                        console.log('Installment count: ', installmentCount);
                        console.log('Pay cycle: ', payCycle);
                        console.log('Pay date of month: ', payDateOfMonth);
                        console.log('Semi monthly pay dates: ', semiMonthlyPayDates);
                        console.log('Reference date: ', referenceDate);
                    }

                    var params = {
                        currentDate: this.currentDate.format(InstLoanCalc.ISO_DATE_FORMAT),
                        loanAmount: loanAmount,
                        installmentCount: installmentCount,
                        payCycle: payCycle,
                        payDateOfMonth: payDateOfMonth,
                        semiMonthlyPayDates : semiMonthlyPayDates,
                        referenceDate: referenceDate
                    };

                    //if (this.rqInProgress !== null) {
                    //    this.rqInProgress.abort();
                    //}

                    var timeout = this.settings.sliderTimeout;
                    if (this.updateInProgress !== null) {
                        clearTimeout(this.updateInProgress);
                    }

                    if (isSlider && timeout > 0) {
                        this.updateInProgress = setTimeout(function () { that.doUpdate(params) }, timeout);
                    } else {
                        this.doUpdate(params);
                    }
                },

                doUpdate: function (params) {
                    var that = this;
                    this.rqInProgress = $.get(this.settings.calcApiUrl, params, function (resp) {

                        that.$nextRolloverFee.html(that.formatMoney(resp.installmentAmount));
                        that.$endDateLabel.html(that.toDate(resp.nextInstallmentDate).format(that.settings.dateFormat));
                        that.$principalAmount.html(that.formatMoney(resp.principalAmount));
                        that.$commAmount.html(that.formatMoney(resp.interestAmount));
                        that.$totalAmount.html(that.formatMoney(resp.totalAmount));
                        that.$fullAgTermEndDateLabel.html(that.toDate(resp.lastInstallmentDate).format(that.settings.dateFormat));
                        that.$installmentCountLabel.html(that.formatMoney(resp.installmentCount));

                        that.$scheduleBtn.data('result', resp);
                        that.$scheduleBtn.attr('data-result', JSON.stringify(resp));

                        if (that.settings.persistValues) {
                            Cookies.set('inst_calc', {
                                loanAmount: params.loanAmount,
                                installmentCount: params.installmentCount,
                                payCycle: that.payCycle,
                                nextPayDate: (that.nextPayDate === null || that.payCycle == 'monthly' ? '' : that.nextPayDate.format(InstLoanCalc.ISO_DATE_FORMAT)),
                                payDateOfMonth: (that.payDateOfMonth === null|| that.payCycle != 'monthly' ? '' : that.payDateOfMonth),
                                semiMonthlyPayDates: (that.semiMonthlyPayDates === null|| that.payCycle != 'semi_monthly' ? '' : that.semiMonthlyPayDates),
                            });
                        }

                        var placeholders = {
                            loanAmount: MoneyTool.format(resp.principalAmount),
                            interest: MoneyTool.format(resp.interestAmount),
                            vat: 0,
                            totalExclVat: MoneyTool.format(resp.totalAmount),
                            total: MoneyTool.format(resp.totalAmount),
                            apr: resp.apr,
                            payCycle: that.settings.payCycles[that.payCycle],
                            firstInstallmentDate: that.toDate(resp.firstInstallmentDate).format(that.settings.dateFormat),
                            nextInstallmentDate: that.toDate(resp.nextInstallmentDate).format(that.settings.dateFormat),
                            repaymentDate: that.toDate(resp.lastInstallmentDate).format(that.settings.dateFormat),
                            agTermEndDate: that.toDate(resp.lastInstallmentDate).format(that.settings.dateFormat),
                            installmentAmount: MoneyTool.format(resp.installmentAmount),
                            installmentCount: resp.installmentCount
                        };
                        that.$repaymentTooltip.attr('href', that.$repaymentTooltip.data('url') + '?values=' +  encodeURI(JSON.stringify(placeholders)));

                        if (that.settings.onUpdate !== null) {
                            that.settings.onUpdate({
                                loanAmount: params.loanAmount,
                                payCycle: that.payCycle,
                                payReferenceDate: that.nextPayDate,
                                payDateOfMonth: that.payDateOfMonth,
                                semiMonthlyPayDates: that.semiMonthlyPayDates,
                                installmentCount: params.installmentCount,
                            });
                        }
                    });
                },

                getMinLoanAmount: function () {
                    return this.toInt(this.settings.minAmount);
                },

                getMaxLoanAmount: function () {
                    return this.toInt(this.settings.maxAmount);
                },

                getStartingInstallmentCount: function() {
                    var min = this.getMinInstallmentCount();
                    var max = this.getMaxInstallmentCount();
                    var installmentCount = this.toInt(this.settings.installmentCount);
                    if (min > installmentCount) {
                        return min;
                    }
                    if (max < installmentCount) {
                        return max;
                    }
                    return installmentCount;
                },

                getMinInstallmentCount: function () {
                    return this.toInt(this.settings.minInstallmentCount);
                },

                getMaxInstallmentCount: function () {
                    return this.toInt(this.settings.maxInstallmentCount);
                },

                getFirstLoanMaxAmount: function () {
                    if (this.settings.authorized) {
                        return this.getMaxLoanAmount();
                    }
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        var lim = limits[i];
                        if (lim.loanNumber == 1) {
                            return this.toInt(lim.maxAmount);
                        }
                    }
                    return this.toInt(this.settings.maxAmount);
                },

                getStartingLoanAmount: function() {
                    var min = this.getMinLoanAmount();
                    var max = this.getMaxLoanAmount();
                    var loanAmount = this.toInt(this.settings.loanAmount);
                    if (min > loanAmount) {
                        return min;
                    }
                    if (max < loanAmount) {
                        return max;
                    }
                    return loanAmount;
                },

                getRequiredLoanNumber: function (loanAmount) {
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        var lim = limits[i];
                        if (this.toInt(loanAmount) <= this.toInt(lim.maxAmount)) {
                            return lim.loanNumber;
                        }
                    }
                    return 1;
                },

                getMinLoanNumberMessage: function (number) {
                    var messages = this.settings.messages;
                    if (number == 2) {
                        return messages.minLoanNumberRequirement2nd;
                    }
                    if (number == 3) {
                        return messages.minLoanNumberRequirement3rd;
                    }
                    if (number == 4) {
                        return messages.minLoanNumberRequirement4th;
                    }
                    var last = null;
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        last = limits[i].loanNumber;
                    }
                    var msg = last == number ? messages.minLoanNumberRequirementLast : messages.minLoanNumberRequirementGeneral;
                    return msg.replace('{number}', number);
                },

                toDecimal: function (number) {
                    return parseFloat(number);
                },
                toInt: function (number) {
                    return parseInt(number, 10);
                },
                toDate: function (string) {
                    return moment(string, InstLoanCalc.ISO_DATE_FORMAT).hours(0).minutes(0).seconds(0).milliseconds(0);
                },
                formatMoney: function (amount) {
                    return this.toInt(amount);
                },

            });

            $.fn[pluginName] = function(options) {
                this.each(function() {
                    if (!$.data(this, "plugin_" + pluginName)) {
                        $.data(this, "plugin_" + pluginName, new InstLoanCalc(this, options));
                    }
                });
                return this;
            };

        })(jQuery, window, document);
    }

    init() {
        ENV === 'development' && console.log('InstalmentCalculator::init()');

        this.defineInstCalcSliderAnimationJqueryPlugin();
        this.defineInstCalcJqueryPlugin();
    }
}

export default new InstalmentCalculator;
